import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { Navigate, useParams } from 'react-router-dom'
import { PositionDetailProvider } from './context/PositionDetailProvider'
import { PositionDetailWorkflowsProvider } from './context/PositionDetailWorkflowProvider'
import { PositionDetailMain } from './PositionDetailMain'
import { EditRequirementFlow } from './workflows/EditRequirementFlow'
import { UnassignRequirementFlow } from './workflows/UnassignRequirementFlow'

export const PositionDetail = () => {
  const { positionId } = useParams()

  if (!positionId || isNaN(Number(positionId))) {
    return <Navigate to="/not-found" />
  }

  return (
    <NuqsAdapter>
      <PositionDetailProvider positionId={Number(positionId)}>
        <PositionDetailWorkflowsProvider>
          <PositionDetailMain />
          <EditRequirementFlow />
          <UnassignRequirementFlow />
        </PositionDetailWorkflowsProvider>
      </PositionDetailProvider>
    </NuqsAdapter>
  )
}
